export const iconFontAwesomeHouseholdDoorOpen = (
	<i className="fa-solid fa-door-open"></i>
);
